// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2dU8b","requiredAsterisk":"Info_requiredAsterisk__2rUFM"};